import React from 'react'
import Nav from "../../Components/Nav/Nav.jsx";
import './CheckReports.css'

import Header from './Header'

export const CheckReports =() =>{

    return (
            <div>
            <Nav title="HEALTHसखा" />
            <Header/>

                
            </div>
        )
}